// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
    $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
}

getCutDownTime();

jQuery("#nav0").slide({
  mainCell: ".nav-imgs",
  autoPlay: true,
  effect: "leftMarquee",
  interTime: 8,
  vis: 2,
  scroll: 2,
});

// new Swiper("#swiper-btn", {
//   autoplay: true,
//   autoplay: {
//     disableOnInteraction: false,
//     // delay: 5000,
//   },
//   loop: true,
//   spaceBetween: 30,
// });


function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            246 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }

  let prods = window.product
  function getCur(){
    let color = $('#color div.active').attr('data-val')
    let size = $('#Size div.active').attr('data-val')
    return prods.filter(item=> item.option1 == color && item.option2 == size)[0]
  }
  function changePrice(){
    let num = $('#calcNumber').val()
    let price = (getCur().price * num / 100).toFixed(2)
    let compare = (getCur().compare_at_price * num / 100).toFixed(2)
    // if(num == 1){
    //   price = (getCur().price * num / 100).toFixed(2)
    // }else if(num == 2){
    //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
    // }else if(num == 3){
    //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
    // }else {
    //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
    // }
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    $('.product-part .price-group .price1 span').html(price)
    $('.product-part .price-group .price2 span').html(compare)
    let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
    $(".product-part .price-group .sp-row span").html(off_font);
  }

  $(".reduce").click(function () {
        let input = $(this).siblings("input")[0];
        let num = Number(input.value) - 1;
        if (num > 0) {
          input.value = num;
          changePrice()
        }
      });
      $(".add").click(function () {
        let input = $(this).siblings("input")[0];
        let num = Number(input.value) + 1;
        input.value = num;
        changePrice()
      });

  let spImgList = [
    [
      'https://cdn.shopify.com/s/files/1/0703/2186/4983/files/1_55802a51-8c29-4fe5-b23b-5587188548d3.png?v=1762935803',
      'https://cdn.shopify.com/s/files/1/0703/2186/4983/files/1_8e824200-6de6-443d-b575-ff1bbfcfa6da.png?v=1762935803',
      'https://cdn.shopify.com/s/files/1/0703/2186/4983/files/1_255b6095-59a3-4a83-8c5b-01cd4cd2dd5b.png?v=1762935803',
      'https://cdn.shopify.com/s/files/1/0703/2186/4983/files/lQDPKej0J4bCELvNAyDNAyCwVNfVMkUmhB4JJFDuRF6-AQ_800_800.jpg?v=1766486981',
      'https://cdn.shopify.com/s/files/1/0703/2186/4983/files/lQDPJwAWlfKBQLvNAyDNAyCwpnvY5sDpC1wJJFDuRF6-AA_800_800.jpg?v=1766486981'
    ],
    [
      'https://cdn.shopify.com/s/files/1/0703/2186/4983/files/2218b0223bfebfb7baca19d71afe89db_67ece26a-b7b8-47a1-ad70-757a1144177c.png?v=1762934529',
      'https://cdn.shopify.com/s/files/1/0703/2186/4983/files/f0939b73ec640c323ce0900eb0875f43_d2bcd62e-95e8-4731-84de-6e54e041d327.png?v=1762934529',
      'https://cdn.shopify.com/s/files/1/0703/2186/4983/files/58a3a03adb1abcd73b2cd22e50c47b3c_d375f6ab-ed32-4906-b6b9-13f906a49b54.png?v=1762934648',
      'https://cdn.shopify.com/s/files/1/0703/2186/4983/files/lQDPJv9o3zAdDHvNAyDNAyCwyOmYBpBiHWMJJFI1N-_5AQ_800_800.jpg?v=1766486981',
      'https://cdn.shopify.com/s/files/1/0703/2186/4983/files/lQDPJwKbasRpTHvNAyDNAyCwZu3VIjf5DpsJJFI1N-_5AA_800_800.jpg?v=1766486981'
    ]
  ]

  $(".option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    changePrice()

    let index1 = $('#color div.active').index()
    let index2 = $('#Size div.active').index()
    $('.product-part .swiper-box img').attr('src', spImgList[index2][index1])
  });

  $(".cart-btn").click(function () {
          $(this).children("img").addClass("on");
          setTimeout(function () {
            $(".cart-btn").children("img").removeClass("on");
            $(".sp-header-top .sp-cart").removeClass("on");
          }, 500);
          $(".sp-header-top .sp-cart").addClass("on");
        });
        
        $(".product-part .cart-btn").click(function () {
          $('.c_toast').show()
          setTimeout(function () {
            $('.c_toast').hide()
          }, 1200);
          
           var data = {
            id: getCur().id,
            quantity: $('#calcNumber').val(),
          };
          
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            success: function () {
              $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
                $("#cardNum").html(result.item_count);
                handleAddToCart(result.item_count);
                $("#calcNumber").val(1);
              });
            },
            dataType: "json",
          });

          var img = $(".product-part .swiper-box img");
          var flyer = img[0].cloneNode(true);
          flyer.classList.add("sp_clone");

          $(".product-part").append(flyer);
          $(".sp_clone").css({
            width: img[0].width,
            height: img[0].height,
            position: "fixed",
            top: 0,
            left: img.offset().left,
            "z-index": "99",
          });

          let finish = $(".sp-cart");
          $(".sp_clone").animate(
            {
              top: finish[0].offsetTop + $(".time-part").height(),
              left: finish[0].offsetLeft + finish.width() / 2,
              width: 50, // 结束时的大小，根据需要调整
              height: 50, // 结束时的大小，根据需要调整
              opacity: 0.4,
              "z-index": "99",
            },
            500,
            "linear",
            function () {
              $(this).animate(
                {
                  width: 0,
                  height: 0,
                  opacity: 0,
                },
                0,
                function () {
                  $(".sp-header-top .sp-cart").addClass("sp-shake");
                  setTimeout(function () {
                    $(".sp-header-top .sp-cart").removeClass("sp-shake");
                  }, 400);
                  $(this).detach();
                }
              );
            }
          );
        });


  $('.buyNow').click(function(){
    let num = $('#calcNumber').val()
    window.location.href = '/cart/' + getCur().id + ':' + num
  })

}

mainRender();
